import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { AdminCard, PageTitle } from "@/pages/admin/AdminLayout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "medium" }) : "");
const ENTITY = { all: "Tutte le entità", booking: "Prenotazioni", bookings: "Export / promemoria", tour: "Tour", package: "Pacchetti", review: "Recensioni", diary_post: "Diario", inquiry: "Richieste", customer: "Clienti", settings: "Impostazioni", admin_user: "Utenti" };
const ACTION = { create: "creazione", update: "modifica", delete: "eliminazione", login: "accesso", export: "export", gdpr_export: "export GDPR", gdpr_erase: "cancellazione GDPR", closed_dates: "date chiuse", resend_email: "reinvio email", run_reminders: "promemoria" };

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entity, setEntity] = useState("all");
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    setLoading(true);
    adminApi.get("/admin/audit-logs", { params: { limit: 300, ...(entity !== "all" ? { entity } : {}) } }).then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, [entity]);

  return (
    <div data-testid="admin-audit">
      <PageTitle title="Registro attività" sub="Chi ha fatto cosa, quando. Registro in sola lettura di tutte le azioni del back-office." />
      <AdminCard className="p-4 mb-5">
        <Select value={entity} onValueChange={setEntity}>
          <SelectTrigger className="sm:w-72 h-11 rounded-xl border-sand bg-white" data-testid="admin-audit-entity"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">{Object.entries(ENTITY).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
        </Select>
      </AdminCard>
      <AdminCard className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-ivory/70 text-[11px] uppercase tracking-[0.15em] text-ocean/55">
              <tr>
                <th className="text-left px-5 py-3 font-medium">Quando</th>
                <th className="text-left px-5 py-3 font-medium">Chi</th>
                <th className="text-left px-5 py-3 font-medium">Azione</th>
                <th className="text-left px-5 py-3 font-medium">Oggetto</th>
                <th className="text-left px-5 py-3 font-medium">Dettagli</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-sand/60">
              {loading && <tr><td colSpan={5} className="px-5 py-10 text-center text-ocean/45">Caricamento...</td></tr>}
              {!loading && rows.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-ocean/45" data-testid="admin-audit-empty">Nessuna attività registrata.</td></tr>}
              {!loading && rows.map((r) => (
                <React.Fragment key={r.id}>
                  <tr className="hover:bg-sand/20 cursor-pointer" onClick={() => setOpenId(openId === r.id ? null : r.id)} data-testid={`admin-audit-row-${r.id}`}>
                    <td className="px-5 py-3 whitespace-nowrap text-ocean/70">{fmt(r.at)}</td>
                    <td className="px-5 py-3 text-ocean">{r.actor}<span className="block text-[11px] text-ocean/45">{r.actor_role}</span></td>
                    <td className="px-5 py-3 text-ocean/80">{ACTION[r.action] || r.action}</td>
                    <td className="px-5 py-3 text-ocean/80">{ENTITY[r.entity] || r.entity}<span className="block text-[11px] text-ocean/45 truncate max-w-[180px]">{r.meta?.slug || r.meta?.ref || r.entity_id}</span></td>
                    <td className="px-5 py-3 text-xs text-ocean/55">{openId === r.id ? "Nascondi" : "Mostra"}</td>
                  </tr>
                  {openId === r.id && (
                    <tr className="bg-ivory/60"><td colSpan={5} className="px-5 py-4">
                      <pre className="text-[11px] text-ocean/75 whitespace-pre-wrap break-words max-h-72 overflow-auto" data-testid="admin-audit-detail">{JSON.stringify({ before: r.before, after: r.after, meta: r.meta, ip: r.ip }, null, 2)}</pre>
                    </td></tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </AdminCard>
    </div>
  );
}
